import { useEffect, useState } from 'react';

// Fuente de verdad para breakpoints responsive EPL
export function useBreakpoint() {
  const [width, setWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isDesktop = width >= 1025;
  const isCompact = width <= 1024;

  return { width, isDesktop, isCompact };
}

export default useBreakpoint;
